import React from "react";

export default function Roadmap() {
  return (
    <div className="roadmap">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1>Roadmap</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <h5>Stage 1</h5>
            <h6>
              50k net worth treasury <br /> metaverse gallery <br /> dao
              dashboard
            </h6>
          </div>
          <div className="col-md-4">
            <h5>Stage 2</h5>
            <h6>
              150k net worth treasury <br /> 10.000 holders <br /> LA gallery
            </h6>
          </div>
          <div className="col-md-4">
            <h5>Stage 3</h5>
            <h6>
              custom nft line <br /> 100m marketcap <br /> cex listing
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
}
